/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlanAssetListItemResponseDto } from './PlanAssetListItemResponseDto';
import {
    PlanAssetListItemResponseDtoFromJSON,
    PlanAssetListItemResponseDtoFromJSONTyped,
    PlanAssetListItemResponseDtoToJSON,
    PlanAssetListItemResponseDtoToJSONTyped,
} from './PlanAssetListItemResponseDto';
import type { PaginationMetaDto } from './PaginationMetaDto';
import {
    PaginationMetaDtoFromJSON,
    PaginationMetaDtoFromJSONTyped,
    PaginationMetaDtoToJSON,
    PaginationMetaDtoToJSONTyped,
} from './PaginationMetaDto';

/**
 * 
 * @export
 * @interface ListPlanAssetsResponseDto
 */
export interface ListPlanAssetsResponseDto {
    /**
     * 
     * @type {Array<PlanAssetListItemResponseDto>}
     * @memberof ListPlanAssetsResponseDto
     */
    data: Array<PlanAssetListItemResponseDto>;
    /**
     * 
     * @type {PaginationMetaDto}
     * @memberof ListPlanAssetsResponseDto
     */
    meta: PaginationMetaDto;
}

/**
 * Check if a given object implements the ListPlanAssetsResponseDto interface.
 */
export function instanceOfListPlanAssetsResponseDto(value: object): value is ListPlanAssetsResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListPlanAssetsResponseDtoFromJSON(json: any): ListPlanAssetsResponseDto {
    return ListPlanAssetsResponseDtoFromJSONTyped(json, false);
}

export function ListPlanAssetsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListPlanAssetsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(PlanAssetListItemResponseDtoFromJSON)),
        'meta': PaginationMetaDtoFromJSON(json['meta']),
    };
}

export function ListPlanAssetsResponseDtoToJSON(json: any): ListPlanAssetsResponseDto {
    return ListPlanAssetsResponseDtoToJSONTyped(json, false);
}

export function ListPlanAssetsResponseDtoToJSONTyped(value?: ListPlanAssetsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(PlanAssetListItemResponseDtoToJSON)),
        'meta': PaginationMetaDtoToJSON(value['meta']),
    };
}

